import { useQuery } from "@tanstack/react-query";
import { useClient } from "./useClient";
import { useEnvContext } from "../contexts/env-context";

export function usePhotoStores(loadConnectionInfo = true): {
	data: eXpress.core.IPhotoStore[] | undefined;
	isLoading: boolean; // TODO: isPending
} {
	const client = useClient();
	const { account, language, pointOfSaleId } = useEnvContext();
	const accountId = account?.id;
	const hasAccount = eXpress.AccountId.isNotEmpty(accountId);

	const photoStoresResult = useQuery({
		queryFn: () => client.getPhotoStoresAsync(),
		queryKey: ["photoStores", language, pointOfSaleId],
		enabled: hasAccount,
	});

	const connectedPhotoStoresResults = useQuery({
		queryFn: () => client.getConnectedPhotoStoresAsync(),
		queryKey: ["connectedPhotoStores", accountId, language, pointOfSaleId],
		enabled: hasAccount && loadConnectionInfo,
	});

	if (!hasAccount) {
		return {
			isLoading: false,
			data: [],
		};
	}
	const { isSuccess } = connectedPhotoStoresResults;
	return isSuccess ? connectedPhotoStoresResults : photoStoresResult;
}
